import React from 'react';
import './header.scss';

export const Header = (props) => {
    return( 
        <div className="header-layout-topbar">
            { props.children }
        </div>
    )
}

export const Menu = (props) => {
    return( 
        <div className="header-menu">
            { props.children }
        </div>
    )
}